import { createContext } from "react";
import { GroupOwnerContextProps } from "../../types/contexts/groupOwnerContext/groupOwnerContextProps.types";

const GroupOwnerContext = createContext({} as GroupOwnerContextProps);

export default GroupOwnerContext;
